import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import Env from '@ridango/core/env';
import { ApplicationFacade, NotificationFacade } from '@ridango/components';
import { TranslateService } from '@ngx-translate/core';
import { ExtendedRoute } from '@ridango/components/lib/open-trip-planner/journey-planner-filter.model';

@Component({
    selector: 'rwidget-planner-routes-modal',
    templateUrl: './journey-planner-routes-modal.component.html',
    styleUrls: ['./journey-planner-routes-modal.component.scss']
})
export class JourneyPlannerRoutesModalComponent implements OnInit {
    assetsPath$ = this.applicationFacade.assetsPath$;
    @Input() routes: ExtendedRoute[];
    @Input() selectedRoutes: string[];
    @Output() routesSelected = new EventEmitter<ExtendedRoute[]>();
    filteredRoutes: ExtendedRoute[] = [];
    checkedRoutesLimit = this.env?.JOURNEY_PLANNER?.FILTERS?.FILTER_ROUTES_LIMIT ?? 5;

    constructor(
        @Inject('ENV') public env: Env,
        private modalCtrl: ModalController,
        private applicationFacade: ApplicationFacade,
        private notification: NotificationFacade,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        // Deselect all routes when the modal is opened and filters are set
        if (this.selectedRoutes.length === 0) {
            this.routes = this.routes.map((route) => ({ ...route, selected: false }));
        }
        this.filteredRoutes = this.routes;
    }

    public routeColor(route: ExtendedRoute): string {
        return route.color;
    }

    public resetAll(): void {
        this.routes = this.routes.map((route) => ({ ...route, selected: false }));
        this.filteredRoutes = [...this.routes];
    }

    public chooseRoutes(): void {
        this.modalCtrl.dismiss(this.routes, 'selected');
    }

    public onCheckboxChange(route: ExtendedRoute, event: Event): void {
        const inputElement = event.target as HTMLInputElement;

        if (this.getSelectedRoutes().length >= this.checkedRoutesLimit) {
            this.notification.info(this.translate.instant('ROUTE_SELECTION_LIMIT_REACHED'));
            inputElement.checked = false;
            return;
        }

        route.selected = inputElement.checked;
    }

    public filterRoutes(event: Event): void {
        const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();

        if (!searchTerm) {
            this.filteredRoutes = this.routes;
        } else {
            this.filteredRoutes = this.routes.filter(
                (route) =>
                    route.shortName.toLowerCase().includes(searchTerm) ||
                    route.longName.toLowerCase().includes(searchTerm)
            );
        }
    }

    public closeModal(): void {
        this.modalCtrl.dismiss(null, 'cancel');
    }

    public getSelectedRoutes(): ExtendedRoute[] {
        return this.routes.filter((route) => route.selected);
    }
}
